import { type AfterViewInit, Component, type OnDestroy } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { FormViewService } from '@xilo-mono/form-contracts';
import { SubmissionSessionService } from '../../services/submission-session.service';
import { ReplaySubject } from 'rxjs';
import { changeInputCSS } from '../helper/form';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'xilo-mono-form-viewer-last-name',
  templateUrl: './last-name.component.html',
  styleUrls: ['../../form-viewer.component.scss', './last-name.component.scss'],
})
export class CustomLastNameComponent extends FieldType implements AfterViewInit, OnDestroy {
  isInvalid = false;
  errorMessage = false;
  changeInputCSS = changeInputCSS;
  private readonly destroyed$ = new ReplaySubject<boolean>(1);
  private readonly metadataKey = 'lastName'; // Define the key for this component

  constructor(
    public formViewService: FormViewService,
    private submissionSessionService: SubmissionSessionService
  ) {
    super();
  }

  ngAfterViewInit(): void {
    if (!this.formControl) {
      console.error('LastNameComponent: formControl is missing in ngAfterViewInit.');
      return;
    }
    // Register with the specific key
    this.submissionSessionService.registerField(this.formControl as FormControl, this.field, this.metadataKey);
  }

  ngOnDestroy() {
    // Unregister with the specific key
    this.submissionSessionService.unregisterField(this.field, this.metadataKey);
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  handleBlur(event: FocusEvent) {
    if (!this.formControl) {
      console.error('LastNameComponent: formControl is missing in handleBlur.');
      return;
    }
    // Call service with the specific key
    this.submissionSessionService.handleBlur(this.formControl as FormControl, this.field, this.metadataKey);
  }

  getError() {
    if (this.formControl?.hasError('required')) {
      return 'This field is required.';
    }
    return this.formControl?.invalid && this.formControl?.touched ? 'Invalid response' : '';
  }
}
